import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import has from '@dojo/framework/core/has';

import { lccstate } from 'lcc-state';

import css from '../css/splash.m.css';

const factory = create({ theme, lccstate }).properties<{ isDynamic?: boolean; content?: string[] }>();

export const Splash = factory(({ properties, middleware: { theme, lccstate } }) => {
	const { get, path } = lccstate;
	const title = get(path('title'));
	const product = get(path('product'));
	const { isDynamic = false, content = [] } = properties();

	const themeCss = theme.classes(css);

	const imageSplash = v('div', { classes: [theme.variant(), themeCss.root] }, [
		v('div', { classes: [themeCss.splash] }, [
			v('img', {
				xqa: 'splash',
				alt: `${title} ${product}`,
				src: `${window.hcstatic.portal_cdn}/js/images/${product}-splash.png`
			})
		])
	]);

	const badgeExtension = has('use-png-badge-logo') ? '.png' : '.svg';

	const textSplash = isDynamic
		? v('div', { classes: [theme.variant(), themeCss.dynamicRoot] }, [
				v('div', { classes: [theme.variant(), themeCss.dynamicContainer] }, [
					v('div', { classes: [themeCss.textContainer], xqa: 'splash-text-container' }, [
						v('img', {
							xqa: 'text-splash-logo',
							alt: `${title} ${product}`,
							src: `${window.hcstatic.portal_cdn}/js/images/${product}/badge${badgeExtension}`
						}),
						v('p', {
							classes: [themeCss.dynamicText],
							xqa: 'splash-text',
							innerHTML: content[Math.floor(Math.random() * content.length)]
						})
					])
				])
		  ])
		: null;

	return isDynamic ? textSplash : imageSplash;
});
